import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ModuleName } from 'src/app/middleware/common/Enum/common.enum';
import { AddEmailActionComponent } from 'src/app/middleware/common/addEmailAction/addEmailAction.component';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { AddCustomInfoComponent } from 'src/app/middleware/common/addCustomInfo/addCustomInfo.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { ImportAutomationTemplateComponent } from 'src/app/middleware/common/importautomationTemplate/importautomationTemplate.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { tap } from 'rxjs/operators';
import { AddTaskTempCategoryComponent } from 'src/app/middleware/common/addTaskTempCategory/addTaskTempCategory.component';
@Component({
  selector: 'app-automations',
  templateUrl: './automations.component.html',
  styleUrls: ['./automations.component.scss']
})
export class AutomationsComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any = [];
  myOfficeID: any;

  @Input() mainModulename: string = "";
  getTagListResponseHolder: any;

  AllCustomInfoList: any[] = [];
  AllCustomInfoListShow: boolean = false;
  CustomInfoTypeForFilter: any[] = [];
  CustomInfoType: any[] = [];
  showCreateTask: boolean = false;
  taskId: number = 0;
  searchText: string = "";
  selectedCategory: string = "All";
  taskList: any[] = [];
  ShowNoRecordFound: boolean = false;
  pageSize: number = 300;
  pageIndex: number = 1;
  preoritytext: string = "Priority";
  IsAssignedToMe: boolean = false;
  IsAssignedToMyRole: boolean = false;
  IsAllTask: boolean = true;
  IsCreatedByMe: boolean = false;
  isMyTaskFilterSelected: boolean = false;
  completedTaskStatusID: any = 0;
  value: string = '';
  spinner: boolean = false;
  taskListFolderID: number = 0;
  taskListID: number = 0;
  taskLists: any = [] = [];
  expandedIndex: number = 0;
  expandedIndexmoveTo: number = 0;
  preorityArray: any = [];
  isOverDue: boolean = false;
  isDuedate: boolean = false;
  dateFrom: any = null;
  dateTo: any = null;
  @Input() transactionID: number = 0;
  typeIdForTask: number = 1;
  moduleNames = "3C"

  //@Input() transactionID: number = 0;
  @Input() typeId: number = 0;
  @Input() name: string = "";
  @Input() email: string = "";
  @Input() imageUrl: string = "";
  @Input() entityId: number = 0;
  @Input() TypeIdDrp: number = 0;
  active: number = 0;
  completed: number = 0;
  paused: number = 0;
  total: number = 0;
  menuModulesList: any = [] = [];
  CoreShowName: string = "";
  ContactShowName: string = "";
  CompanyShowName: string = "";
  showTaskDetail: boolean = false;
  showProcess: boolean = false;
  mainModuleName: string = '';
  SingleTaskArchived: boolean = false;
  showAddGroupButtonCore: boolean = false;
  rolesAsssign: any = [] = [];
  isSuperAdmin: boolean = false;

  constructor(private dialog: MatDialog, private taskService: SettingService,
    private statusConst: StatusConstant, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private loaderService: LoaderService,
    private toastr: ToastrService, private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList') || '[]');
    offices.forEach((oe: any) => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {
    this.menuModulesList = JSON.parse(sessionStorage.getItem('menuModules') || '[]');
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter((x: any) => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
    }

    SelectedContact = this.menuModulesList.filter((x: any) => x.mainModuleName == 'Contact');
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;
    }

    SelectedCompany = this.menuModulesList.filter((x: any) => x.mainModuleName == 'Company');
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;
    }
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles") ?? "[]");
    if (this.rolesAsssign.length > 0) {
      // this.isOfficeAdmin = this.rolesAsssign.find(m => m.roleName == 'Office Admin') != undefined;
      this.isOrganizationAdmin = this.rolesAsssign.find((m: any) => m.roleName == 'Organization Admin') != undefined;
      this.isSuperAdmin = this.rolesAsssign.find(m => m.roleName == 'Super Admin') != undefined;

    }
    this.mainModulename;
    this.getTasks();
  }

  getTasks() {
    this.ShowNoRecordFound = false;
    this.loaderService.show();
    var ReqModel = {
      "paging": {
        "pageSize": this.pageSize,//pageData.pageSize,
        "pageIndex": this.pageIndex  //pageData.pageIndex,
      },
      filter: {
        IsAssignedToMe: this.IsAssignedToMe,
        IsAssignedToMyRole: this.IsAssignedToMyRole,
        IsCreatedByMe: this.IsCreatedByMe,
        IsAllTask: this.IsAllTask,
        title: this.value,
        description: "",
        attachedTitle: "",
        taskListID: this.taskListID,
        TaskListFolderID: this.taskListFolderID,
        createdOn: {
          from: null,
          to: null
        },
        assignedOn: {
          from: null,
          to: null
        },
        assignees: [
          0
        ],
        Priority: this.preorityArray,
        byDate: {
          from: this.dateFrom,
          to: this.dateTo
        },
        isOverDue: this.isOverDue,
        dueDate: this.isDuedate,
        status: 0,
        attachmentType: 0
      },
      transaction: {
        transactionID: this.transactionID,
        typeId: this.typeIdForTask //1
      },
      isArchived: false,
      taskType: 2, // 0-External, 1-Internal ,2-Both
      automation: 1,
      level: 1,
      scheduleType: 0,
      scheduledTask: false,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.taskList = [];
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskList = response?.data?.tasks ?? [];
          if (this.taskList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }

          this.active = response?.data?.automationTaskCounts?.active ?? 0;
          this.completed = response?.data?.automationTaskCounts?.completed ?? 0;
          this.paused = response?.data?.automationTaskCounts?.paused ?? 0;
          this.total = response?.data?.automationTaskCounts?.total ?? 0;
        } else {
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.loaderService.hide();
        }
      } else {
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }



  createAutomation() {
    this.showCreateTask = true;
  }

  getCloseCreateTask() {
    this.showCreateTask = false;
  }

  getSaveTask() {
    this.getTasks();
  }


  getAssigne(item: any) {
    const allAssignee = [];
    if (item && item.length > 1) {
      item.forEach((item: any) => {
        if (item.assigneeName) {
          allAssignee.push({ name: item.assigneeName, image: item.imageUrl });
        } else if (item.roleName) {
          allAssignee.push({ name: item.roleName, image: item.imageUrl });
        } else if (item.email) {
          allAssignee.push({ name: item.email, image: item.imageUrl });
        }


      })
    } else {
      if (item[0]?.assigneeName) {
        allAssignee.push({ name: item[0].assigneeName, image: item[0].imageUrl });
      } else if (item[0]?.roleName) {
        allAssignee.push({ name: item[0].roleName, image: item[0].imageUrl });
      } else if (item[0]?.email) {
        allAssignee.push({ name: item[0].email, image: item[0].imageUrl });
      }

    }
    return allAssignee
  }

  getShortName(fullName: any) {
    if (fullName != undefined) {
      if (fullName.includes(' ')) {
        return fullName
          .split(' ')
          .map((n: any) => n[0])
          .join('');
      }
      return fullName.substring(0, 1);
    }
    return '';
  }

  getAttach(item: any) {

    const allAttach: any = [];
    if (item) {
      item.forEach((item: any) => {
        allAttach.push(item.attachedEntityName);
      })
    }
    return allAttach ? allAttach : "-"

    //return item[0]?.attachedEntityName ? item[0]?.attachedEntityName : "-"
  }

  getAttachShortName(items: any[]): string {
    if (!items || !items.length) {
      return '-';
    }

    return items
      .filter((x: any) => x.attachedEntityName)
      .map(x =>
        x.attachedEntityName
          .trim()
          .split(/\s+/)
          .map((word: string) => word[0].toUpperCase())
          .join('')
      )
      .join(', ');
  }

  trackByFn(index: any, item: any) {
    return index; // or item.id
  }

  deleteTask(task: any) {
    const message = `Are you sure you want to delete this task?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var taskId = 0;
          taskId = task.taskId
          // if (task.taskId == undefined) {
          //   taskId = task.taskId;
          // } else {
          //   taskId = task.taskId;
          // }
          var reqModel = {
            taskIds: [taskId],
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.taskService.removeTasks(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.getTasks();
                this.loaderService.hide();
                this.toastr.success('Task deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
                this.toastr.error('Task deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  changeAutomationStatus(value: any, task: any): void {
    const selectedStatus = Number(value);
    const ReqModel = {
      taskID: task.taskId,
      status: selectedStatus,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    };
    this.loaderService.show();
    this.taskService.updateTaskAutomationStatus(ReqModel).subscribe((response: any) => {
      this.loaderService.hide();
      if (response !== undefined && response.status === this.statusConst.statusSuccess) {
        // Keep the selected value updated
        task.automationStatus = selectedStatus;
        this.getTasks();
        this.toastr.success("Status updated successfully.");
      } else {
        this.loaderService.hide();
        this.toastr.error("Status update failed.");
      }
    },
      (error: any) => {
        this.loaderService.hide();
        this.toastr.error("Status update failed.");
      }
    );
  }

  closeTaskDetail(messages: boolean) {
    this.showTaskDetail = messages;
    const body = document.body;
    body.classList.remove('removeTabarrows');
  }

  closeSaveTaskDetail(messages: boolean) {
    this.showTaskDetail = messages;
    this.getTasks();
  }

  showPIntelligence(messages: boolean) {
    this.showProcess = messages;
  }

  closePIntelligence(messages: boolean) {
    this.showProcess = messages;
  }

  getTaskDetail(task: any) {
    const body = document.body;
    body.classList.add('removeTabarrows');
    this.taskId = task.taskId;
    this.showTaskDetail = true;
  }

  getRepeatDays(task: any): string {
    if (!task?.scheduleData) {
      return '';
    }

    try {
      const data = typeof task.scheduleData === 'string'
        ? JSON.parse(task.scheduleData)
        : task.scheduleData;

      if (!Array.isArray(data?.RepeatDays)) {
        return '';
      }

      const days = data.RepeatDays
        .filter((x: any) => x?.RepeatDay != null)
        .map((x: any) => x.RepeatDay)
        .join(',');

      return days ? `Day ${days}` : '';

    } catch {
      return '';
    }
  }



  ImportTaskTemplate() {
    const dialogRef = this.dialog.open(ImportAutomationTemplateComponent, {
      data: {
        // From: "AITools",
        transactionID: this.transactionID,
        typeId: this.typeIdForTask,
        taskListID: this.taskListID,
        entityID: this.entityId,
        cType: this.typeIdForTask,
        name: this.name,
        email: this.email,
        entityTypeID: this.TypeIdDrp,
        // documentId: this.documentId,
        // total: this.rules.length,
      },
      width: '50vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getTasks();
      }
    });
  }


  addTemplateForm: FormGroup;
  categoryType: number = 0;
  showNew: boolean = false;
  showExisting: boolean = false;
  taskCategoryList: any = [] = [];
  filteredTaskCategoryList: any = [] = [];
  AddTaskTemplateMultiple: boolean = false;
  selectedRecordMoveToArray: any = [] = [];
  taslTemplateID: number = 0;
  updateTaskTemplateTasksButton: boolean = false;
  ShowNoRecordFoundTaskTemplates: Boolean = false;
  TaskTemplatesList: any = [] = [];
  FilteredTaskTemplatesList: any = [] = [];
  taskListIDforAddTemplate: number = 0;
  isOrganizationAdmin: boolean = false;
  selectedTemplate: any = [] = [];
  searchTemplateName: string = '';
  addTaskListButton: boolean = false;
  TaskListName: string = "";
  selectedTaskCategoryID: number = 0;
  timeout = null;

  SaveAsTemplate(templateRef: TemplateRef<any>,) {
    //this.AddTaskTemplateMultiple = false;
    //this.taskListFolderID=0;
    //this.taskListID = tasklist.taskListID;
    this.categoryType = 0;
    let group = {};
    this.addTemplateForm = new FormGroup(group);
    this.showNew = true;
    this.showExisting = false;
    this.createSaveAsTaskTemplate();
    this.getActiveTaskTemplateCategories1();
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    }
    );
  }

  createSaveAsTaskTemplate(): void {
    this.addTemplateForm = this.formBuilder.group({
      taskTemplateName: ['', [Validators.required]],
      folderID: ['', [Validators.required]],
    },);
  }

  getActiveTaskTemplateCategories1() {
    this.loaderService.show();
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      type: this.categoryType > 0 ? this.categoryType : 0
    };
    this.taskService.getActiveTaskTemplateCategories(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskCategoryList = response.data;
          this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == this.categoryType);
        } else {
          this.taskCategoryList = [];
          this.filteredTaskCategoryList = [];
        }
      } else {
        this.taskCategoryList = [];
        this.filteredTaskCategoryList = [];
      }
    });
  }

  async updateTaskTemplateTasks(data: any) {
    var itemList = [];
    if (this.AddTaskTemplateMultiple == false) {
      itemList = null;
    }
    if (this.AddTaskTemplateMultiple == true) {
      if (this.selectedRecordMoveToArray.length > 0) {
        for (var i = 0, len = this.selectedRecordMoveToArray.length; i < len; ++i) {
          var obj = {
            taskID: this.selectedRecordMoveToArray[i].selectedRecord,
            position: i + 1
          }
          itemList.push(obj);
        }
      }
    }

    this.loaderService.show();
    var ReqModel = {
      taskTemplateID: this.taslTemplateID,
      tasks: itemList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      TaskListID: this.taskListID
    }
    //return; 
    this.spinner = true;
    // this.updateTaskTemplateTasksButton = false;
    // this.addTemplateForm.markAsPristine();
    const result = await this.taskService.updateTaskTemplateTasks(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
      this.toastr.success("Task template update successfully.", '', {
        timeOut: 3000,
      });
      // this.showMoveToOption = false;
      this.selectedRecordMoveToArray = [];
      // this.selection.clear();
      this.closeSaveAsTemplate();
    }
    else {
      this.toastr.error("Task template add failed.", '', {
        timeOut: 3000,
      });
      // this.showMoveToOption = false;
      this.spinner = false;
      this.loaderService.hide();
    }
  }

  async AddTaskTemplate(data: any) {
    var itemList = [];
    if (this.AddTaskTemplateMultiple == false) {
      itemList = null;
    }
    if (this.AddTaskTemplateMultiple == true) {
      this.taskListID = 0;
      // this.taskListIDSharedWithMe = 0;
      // this.showAddGroupButton = false;
      if (this.selectedRecordMoveToArray.length > 0) {
        for (var i = 0, len = this.selectedRecordMoveToArray.length; i < len; ++i) {
          var obj = {
            taskID: this.selectedRecordMoveToArray[i].selectedRecord,
            position: i + 1
          }
          itemList.push(obj);
        }
      }
    }

    this.loaderService.show();
    var ReqModel = {
      taskTemplateName: data.taskTemplateName,
      position: 0,
      folderID: data.folderID,
      taskListID: this.taskListID,
      tasks: itemList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      type: this.categoryType > 0 ? this.categoryType : 0
    }
    //return; 
    this.spinner = true;
    this.addTemplateForm.markAsPristine();
    const result = await this.taskService.addTaskTemplate(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
      this.toastr.success("Task template added successfully.", '', {
        timeOut: 3000,
      });
      //this.showMoveToOption = false;
      this.selectedRecordMoveToArray = [];
      //this.selection.clear();
      this.closeSaveAsTemplate();
    }
    else {
      this.toastr.error("Task template add failed.", '', {
        timeOut: 3000,
      });
      //this.showMoveToOption = false;
      this.spinner = false;
      this.loaderService.hide();
    }
  }

  SelectTemplateForAddTaskList(temp: any) {

    this.taslTemplateID = temp.taskTemplateID;
    this.updateTaskTemplateTasksButton = true;
  }

  closeSaveAsTemplate() {
    this.taslTemplateID = 0;
    this.addTemplateForm.reset();
    this.taskListFolderID = 0;
    // this.taskListID=0;
    this.dialog.closeAll();
  }


  OnCategoryChange(categoryTypeValue: number) {
    this.TaskTemplatesList = [];
    this.categoryType = categoryTypeValue;
    this.getActiveTaskTemplateCategories1();
    // this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == this.categoryType);
  }

  getSelectTaskCategory(e: any) {
    this.selectedTaskCategoryID = e.value;
    // this.categoryTypeForSingleTask = e.value;
    this.getTaskTemplates();
  }

  getTabDetails(event: any) {
    this.updateTaskTemplateTasksButton = false;
    this.taslTemplateID = 0;
    this.selectedTemplate = [];
    this.TaskTemplatesList = [];
    if (event.tab.textLabel == "New" || event.index == 0) {
      this.showNew = true;
      this.showExisting = false;
      this.getActiveTaskTemplateCategories1();
    }

    if (event.tab.textLabel == "Update Existing" || event.index == 1) {
      this.showNew = false;
      this.showExisting = true;
    }
  }

  searchTemplate(val) {
    if (val.length >= 2) {
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.searchTemplateName = val;
          this.getTaskTemplates();
        }, 500);
      } else {

      }
    } else {
      this.searchTemplateName = "";
      this.getTaskTemplates();
    }
  }

  getTaskTemplates() {
    this.ShowNoRecordFoundTaskTemplates = false;
    this.loaderService.show();
    this.filteredTaskCategoryList = [];
    this.FilteredTaskTemplatesList = [];
    var ReqModel = {
      folderID: this.selectedTaskCategoryID > 0 ? this.selectedTaskCategoryID : 0,
      searchKey: this.searchTemplateName,
      userID: this.currentUser.UID,
      officeID: Number(this.myOfficeID),
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      type: this.categoryType > 0 ? this.categoryType : 0,
      //folderId:this.selectedTaskCategoryID>0?this.selectedTaskCategoryID:0
    };

    this.getActiveTaskTemplateCategories().subscribe(() => {
      this.taskService.getTaskTemplates(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
            this.TaskTemplatesList = response.data;
            if (this.categoryType == 0) {
              this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 0);
              const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
              this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
            }
            if (this.categoryType == 1) {
              this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 1);
              const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
              this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
            }
            if (this.categoryType == 2) {
              this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 2);
              const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
              this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
              // this.FilteredTaskTemplatesList = this.TaskTemplatesList;
            }
            if (this.TaskTemplatesList.length > 0) {
              this.ShowNoRecordFoundTaskTemplates = false;
            } else {
              this.ShowNoRecordFoundTaskTemplates = true;
            }
          } else {
            this.ShowNoRecordFoundTaskTemplates = true;
            this.TaskTemplatesList = [];
            this.FilteredTaskTemplatesList = [];
            this.loaderService.hide();
          }
        } else {
          this.ShowNoRecordFound = true;
          this.loaderService.hide();
        }
      });
    });
  }

  getActiveTaskTemplateCategories(): Observable<any> { // Return type added
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      type: this.categoryType > 0 ? this.categoryType : 0
    };
    return this.taskService.getActiveTaskTemplateCategories(ReqModel).pipe(
      tap(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
            this.taskCategoryList = response.data;
            this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == this.categoryType);
          } else {
            this.taskCategoryList = [];
            this.filteredTaskCategoryList = [];
          }
        } else {
          this.taskCategoryList = [];
          this.filteredTaskCategoryList = [];
        }
      })
    );
  }

  openDialogAddWithRef() {
    const dialogRef = this.dialog.open(AddTaskTempCategoryComponent, {
      data: {
        categoryType: this.categoryType
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getActiveTaskTemplateCategoriesAfterAdd(result);
      }
    });
  }

  getActiveTaskTemplateCategoriesAfterAdd(categoryName: string) {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      type: this.categoryType > 0 ? this.categoryType : 0
    }
    this.taskService.getActiveTaskTemplateCategories(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskCategoryList = response.data;
          this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == this.categoryType);
          var check = [];
          check = this.taskCategoryList.filter((x: any) => x.taskTemplateCategoryName.toLowerCase() == categoryName.toLowerCase());
          if (check.length > 0) {
            this.addTemplateForm.controls['folderID'].setValue(check[0].taskTemplateCategoryID);
          }
        }
        else {
          this.taskCategoryList = [];
          this.filteredTaskCategoryList = [];
        }
      }
      else {
        this.taskCategoryList = [];
        this.filteredTaskCategoryList = [];
      }
    });
  }

}
